import { confirmPasswordResetByEmail } from '../../services/api/accountService'

export const thunkConfirmResetPasswordByEmail =
  (data, setLoading, onSuccess, onError) => async (dispatch) => {
    setLoading(true)
    try {
      const resp = await confirmPasswordResetByEmail(data)
      if (resp?.result === 'ok') {
        onSuccess()
      }
    } catch (error) {
      onError(error.data.message)
    }
    setLoading(false)
  }
